import React from 'react';
import styles from './searchDeck.module.sass';
import { DropDown } from '../../../../DropDown';
import { Checkbox } from '../../../../Checkbox';

export const SearchDeck = ({
  value,
  id,
  placeholder,
  label,
  error,
  loading,
  disabled,
  view,
  deck,
  firstLoading,
  ...props
}) => (
  <DropDown
    firstLoading={firstLoading}
    id={id}
    value={value}
    placeholder={placeholder}
    label={label}
    error={error}
    disabled={disabled}
    view={view}
    {...props}
    content={
      <div className={styles.checkboxes}>
        {deck.map(days => (
          <Checkbox
            key={days}
            name={id}
            disabled={loading}
            value={`${days}`}
            view={view}
          >
            {days}
          </Checkbox>
        ))}
      </div>
    }
  />
);

SearchDeck.defaultProps = {
  error: undefined,
  rangeDays: {},
};
